import PropTypes from 'prop-types';
import React from 'react';

export class ZeroState extends React.Component {
  renderZeroStateHeader() {
    return (
      <div className="zero-state-header">
        {
          this.props.onButtonClick ?
            <button
              type="button"
              className="btn btn-link icon-only visible-xs-inline visible-sm-inline"
              data-toggle="modal" data-target="#newMessage"
              onClick={ this.props.onButtonClick }
            >
              <span className="fa-solid fa-pen-to-square"></span>
            </button>
            : null
        }
      </div>
    );
  }

  render() {
    return (
      <div className="row h-100 align-items-center text-center" ref={ this.props.ref } >
        <div className="col">
          { this.props.showZeroHeader ? this.renderZeroStateHeader() : null }
          <div className="fs-1">
            <span className={(this.props.stateIconCss || '')}></span>
          </div>
          <span tabIndex="0">{ this.props.zeroStateMessage }</span>
        </div>
      </div>
    );
  }
}

ZeroState.propTypes = {
  zeroStateMessage: PropTypes.object,
  stateIconCss: PropTypes.string,
  onButtonClick: PropTypes.func,
  showZeroHeader: PropTypes.bool,
  ref: PropTypes.func,
};
